import type { Environment } from './environment.model';

export const environment: Environment = {
  apiBaseUrl: '',
  gainsightPxKey: 'AP-5PAYV3N1FZOG-2-3',
  aura: {
    apiBaseUrl: 'https://api.uat.ai-assistant.unityaiot.com',
  },
  showLibrary: false,
};
